<template>
  <div class="why-modal flex justify-center"
       @click.stop="closeModal"
  >
    <div class="rounded-sm w-full md:w-auto shadow-md max-h-full"
         :class="[allowFullWidth && 'full-width', overflowVisible ? 'overflow-visible' : 'overflow-y-auto']"
         :style="modalWidth"
         @click.stop
    >
      <div class="modal-title py-4 px-5 items-center"
           :class="title && 'flex justify-between'"
      >
        <h3 v-if="title"
            class="p-0 m-0 text-typeLight"
        >
          {{ title }}
        </h3>
        <div class="close cursor-pointer text-right flex items-center"
             :class="!title && 'inline-block'"
             @click="closeModal"
        >
          <svg class="fill-current text-typeDark inline-block"
               xmlns="http://www.w3.org/2000/svg"
               width="18"
               height="18"
               viewBox="0 0 18 18"
          >
            <path
              d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
            />
          </svg>
        </div>
      </div>
      <div
        class="p-4 max-h-screen"
        :class="overflowVisible ? 'overflow-visible' : 'overflow-y-scroll'"
      >
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    closeModal: {
      type: Function,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    allowFullWidth: {
      type: Boolean,
      default: false
    },
    overflowVisible: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: null
    }
  },
  computed: {
    modalWidth(){
      if (this.allowFullWidth && !this.width) {
        return 'max-width: 95vw; width: 95vw; min-width: 320px;';
      }
      if (!this.width) {
        return 'max-width: 900px;';
      }
      return `max-width: ${this.width}px; min-width: 320px;`;
    }
  }
};
</script>

<style lang="scss" scoped>
.why-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.6);
  padding: 20px;
  z-index: 1;
  > div {
    background-color: white;
    margin: auto;
    min-width: 50%;
    @media (min-width: 992px) {
      @apply max-w-screen-md;
    }
    @media (max-width: 991px) {
      min-width: 80%;
    }
    &.full-width {
      min-width: min(90%, 95vw);
      max-width: 95vw !important;
      width: 95vw;
      @media (min-width: 992px) {
        max-width: 95vw !important;
      }
    }
  }
  .modal-title {
    @apply border-b border-gray-200 bg-gray-100;

    h3 {
      @apply border-none text-typeDark;
    }

    .close {
      transition: all 0.3s ease-in-out;
      &:hover {
      transform: scale(1.2);
    }
    }
  }
}
</style>
